import * as React from 'react';
import { useCallback } from 'react';
import { useTheme } from '../../../theme';
import ParentCounter from '../../../Counter/Counter';
import cn from 'classnames';

export interface Props {
	max?: number;
	min?: number;
	className?: string;
	value?: number;
	isIncreaseDisabled?: boolean;
	isDecreaseDisabled?: boolean;
	onChange?: (value: number) => void;
}

const BaggageCounter: React.FC<Props> = props => {
	const { BaggageCounter: css } = useTheme('BaggageCounter');
	const value = props.value || 0;

	const handlerIncrease = useCallback(() => {
		props.onChange?.(typeof value === 'number' ? value + 1 : 1);
	}, [props.onChange, value, props.isIncreaseDisabled]);

	const handlerDecrease = useCallback(() => {
		props.onChange?.(typeof value === 'number' ? value - 1 : 1);
	}, [props.onChange, value, props.isDecreaseDisabled]);

	return (
		<ParentCounter
			classes={{
				root: cn(css.root, props.className),
				plus: css.plus,
				minus: cn(css.minus, {
					[css.hidden]: !props.value
				}),
				value: cn(css.value, {
					[css.hidden]: !props.value
				})
			}}
			value={value}
			isDecreaseDisabled={props.isDecreaseDisabled}
			isIncreaseDisabled={props.isIncreaseDisabled}
			onIncrease={handlerIncrease}
			onDecrease={handlerDecrease}
			maxValue={props.max}
			minValue={props.min}
		/>
	);
};

export default BaggageCounter;
